import styled from "styled-components";

export const ContentField = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-auto-rows: 1em auto;
  align-items: center;
  @media only screen and (max-width: 480px) {
    grid-template-columns: inherit;
    grid-auto-rows: inherit;
    width: 70vw;
    grid-column: 1;
  }

  label {
    grid-column: 1/3;
    color: rgba(123, 123, 123, 1);
    font-size: 14px;
  }
`;
